import React from 'react';

const DataManagement = () => {
  return ( <h1>Data Management</h1> );
}
 
export default DataManagement;